/**
 * Phase 16.R7: local caption state so keystrokes do not re-render Posts + ML panels.
 * Parent receives form updates only after debounce (≥400ms) or blur.
 */
import React, { useEffect, useState, memo } from 'react';
import { TextField } from '@mui/material';
import useDebouncedValue from '../../hooks/useDebouncedValue';

const DEBOUNCE_MS = 400;

function PostCaptionField({
  defaultValue = '',
  onDebouncedChange,
  onBlurCommit,
  onLiveChange,
  ...textFieldProps
}) {
  const [value, setValue] = useState(defaultValue || '');
  const debounced = useDebouncedValue(value, DEBOUNCE_MS);

  useEffect(() => {
    onDebouncedChange?.(debounced);
  }, [debounced, onDebouncedChange]);

  return (
    <TextField
      {...textFieldProps}
      name="content"
      value={value}
      onChange={(e) => {
        const next = e.target.value;
        setValue(next);
        onLiveChange?.(next);
      }}
      onBlur={(e) => {
        onBlurCommit?.(value);
        textFieldProps.onBlur?.(e);
      }}
    />
  );
}

export default memo(PostCaptionField);
